// Async ID-verification job states returned by the backend /verification/status endpoint.
// NONE is the backend's sentinel for "no check has been run for this document yet" — it is a
// normal state (the panel offers to run one), not an error.
export const VERIFICATION_STATUS = {
    NONE: 'none',
    PENDING: 'pending',
    PROCESSING: 'processing',
    COMPLETED: 'completed',
    FAILED: 'failed',
};

// Staff decision sent to the /verification/review endpoint. No auto-decision — always staff-chosen.
export const REVIEW_DECISION = {
    APPROVED: 'approved',
    REJECTED: 'rejected',
    ESCALATED: 'escalated',
};

// Plain-language match-score bands (staff aren't ML engineers — never show a raw decimal).
// Thresholds are a tunable product decision; start conservative for a prescribing context.
export const STRONG_MATCH_THRESHOLD = 0.90;
export const REVIEW_MATCH_THRESHOLD = 0.70;

export const MATCH_BAND = {
    STRONG: { key: 'strong', label: 'Strong match', color: 'success' },
    REVIEW: { key: 'review', label: 'Review recommended', color: 'warning' },
    LOW: { key: 'low', label: 'Low match', color: 'danger' },
    UNKNOWN: { key: 'unknown', label: 'No score', color: 'secondary' },
};
